import { GET_TAGS_SUCCESS, APPEND_TAGS_SUCCESS, CLEAR_TAGS } from "./types";
const initialState = {
    items: [],
    page: 0,
    size: 20,
    last: false,
    totalElements: 0,
    totalPages: 0,
};
export const tagsReducer = (state = initialState, action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    switch (action.type) {
        case GET_TAGS_SUCCESS: {
            const p = action.payload;
            console.log('p: ', p);
            return {
                items: (_a = p.content) !== null && _a !== void 0 ? _a : [],
                page: (_b = p.number) !== null && _b !== void 0 ? _b : 0,
                size: (_c = p.size) !== null && _c !== void 0 ? _c : state.size,
                last: (_d = p.last) !== null && _d !== void 0 ? _d : false,
                totalElements: (_e = p.totalElements) !== null && _e !== void 0 ? _e : 0,
                totalPages: (_f = p.totalPages) !== null && _f !== void 0 ? _f : 0,
            };
        }
        case APPEND_TAGS_SUCCESS: {
            const p = action.payload;
            const next = [...state.items];
            for (const t of (_g = p.content) !== null && _g !== void 0 ? _g : []) {
                if (!next.some((x) => x.tagId === t.tagId))
                    next.push(t);
            }
            return {
                items: next,
                page: (_h = p.number) !== null && _h !== void 0 ? _h : state.page,
                size: (_j = p.size) !== null && _j !== void 0 ? _j : state.size,
                last: (_k = p.last) !== null && _k !== void 0 ? _k : state.last,
                totalElements: (_l = p.totalElements) !== null && _l !== void 0 ? _l : state.totalElements,
                totalPages: (_m = p.totalPages) !== null && _m !== void 0 ? _m : state.totalPages,
            };
        }
        case CLEAR_TAGS:
            return Object.assign(Object.assign({}, initialState), { size: state.size });
        default:
            return state;
    }
};
